// eslint-disable-next-line no-unused-vars
import { all, call, put, takeEvery, select } from 'redux-saga/effects';

import { actions } from '../../utils/constants';

import {
    fetchEnrollments,
    fetchSomeUsers,
    withRetry,
    saveNewUser,
    editUser,
    fetchUser,
} from '../../utils/common-functions';

function* fetchCoaches({ payload }) {
    yield put({
        type: actions.USERS_FETCH_LOADING,
        payload: { loading: true },
    });
    try {
        const response = yield call(withRetry(fetchSomeUsers), payload);
        yield put({
            type: actions.SOME_USERS_FETCHED,
            payload: {
                some: response.data.coaches,
                total: parseInt(response.data.total, 10),
                pages: Math.ceil(response.data.total / payload.pageSize),
            },
        });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'Os usuários não puderam ser carregados. Tente recarregar a página',
            },
        });
    }
    yield put({
        type: actions.USERS_FETCH_LOADING,
        payload: { loading: false },
    });
}

function* fetchAllCoaches({ payload }) {
    yield put({ type: actions.ALL_USERS_FETCHED, payload: { all: [] } });
    yield put({
        type: actions.USERS_FETCH_LOADING,
        payload: { loading: true },
    });
    try {
        const response = yield call(withRetry(fetchSomeUsers), {
            ...payload,
            pageSize: 100,
            page: 0,
        });
        const pages = Math.max(Math.ceil(response.data.total / 100), 1);

        const responses = [];
        for (let page = 1; page < pages; page++) {
            responses.push(
                yield call(withRetry(fetchSomeUsers), {
                    ...payload,
                    pageSize: 100,
                    page,
                }),
            );
        }

        /* const requests = [];
        for (let page = 1; page < pages; page++) {
            requests.push(call(withRetry(fetchSomeUsers), { ...payload, pageSize: 100, page }));
        }
        const responses = yield all(requests); */
        yield put({
            type: actions.ALL_USERS_FETCHED,
            payload: {
                all: [
                    ...response.data.coaches,
                    ...responses.reduce(
                        (r, item) => [...r, ...item.data.coaches],
                        [],
                    ),
                ],
            },
        });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'Os usuários não puderam ser carregados. Tente recarregar a página',
            },
        });
    }
    yield put({
        type: actions.USERS_FETCH_LOADING,
        payload: { loading: false },
    });
}

function* fetchOneUserDataByClass({ payload }) {
    yield put({
        type: actions.USERS_FETCH_LOADING,
        payload: { loading: true },
    });
    try {
        const classEnrollments = yield call(withRetry(fetchEnrollments), {
            ...payload,
            withUserData: true,
        });

        const coaches = classEnrollments.data.map(
            ({ userId, name, email }) => ({ userId, name, email }),
        );
        yield put({ type: actions.USER_DATA_FETCHED, payload: { coaches } });
    } catch (e) {
        yield put({
            type: actions.USER_DATA_FETCHED,
            payload: { coaches: [] },
        });
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'Os dados dos usuários não puderam ser carregados. Tente recarregar a página',
            },
        });
    }
    yield put({
        type: actions.USERS_FETCH_LOADING,
        payload: { loading: false },
    });
}

function* fetchUserEnrollments({ payload }) {
    yield put({
        type: actions.USERS_FETCH_LOADING,
        payload: { loading: true },
    });
    try {
        const enrollments = yield fetchEnrollments(payload);

        yield put({
            type: actions.USER_ENROLLMENTS_FETCHED,
            payload: { enrollments: enrollments.data },
        });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'As matrículas do usuário não puderam ser carregadas. Tente recarregar a página',
            },
        });
    }
    yield put({
        type: actions.USERS_FETCH_LOADING,
        payload: { loading: false },
    });
}

function* asyncEditNewUser({ payload }) {
    yield put({ type: actions.EDIT_NEW_USER, payload });
}

function* asyncCreateUser() {
    let alerts = yield select(({ App }) => App.alerts);
    const { newUser } = yield select(state => state.users);
    yield put({ type: actions.TOGGLE_WAIT_FOR_REQUEST, payload: true });

    try {
        yield call(saveNewUser, newUser);
        yield put({ type: actions.TOGGLE_WAIT_FOR_REQUEST, payload: false });
        alerts.push({
            type: 'success',
            title: 'Sucesso',
            message: 'Usuário cadastrado com sucesso',
        });
        yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
        yield put({ type: actions.CLEAR_NEW_USER });
        yield put({
            type: actions.CHANGE_REDIRECT_TO_TABLE_USERS,
            payload: true,
        });
    } catch (error) {
        yield put({ type: actions.TOGGLE_WAIT_FOR_REQUEST, payload: false });
        if (
            error.response.data.error_description ===
            'Invalid phone number format.'
        ) {
            alerts.push({
                type: 'error',
                title: 'Erro',
                message: 'Número de telefone inválido. Tente novamente',
            });
            yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
        } else {
            alerts.push({
                type: 'error',
                title: 'Erro',
                message: 'Usuário não cadastrado. Tente novamente',
            });
            yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
        }
    }
}

function* initEditUser({ payload }) {
    yield put({ type: actions.TOGGLE_WAIT_FOR_REQUEST, payload: true });
    try {
        const { data } = yield call(fetchUser, payload.data.id);
        yield put({
            type: actions.SET_NEW_USER,
            payload: { ...payload.data, ...data },
        });
        yield put({ type: actions.IS_THIS_EDITING, payload: true });
        yield put({ type: actions.TOGGLE_SHOW_FORM, payload: true });
    } finally {
        yield put({ type: actions.TOGGLE_WAIT_FOR_REQUEST, payload: false });
    }
}

function* finishEditUser({ payload }) {
    const { callback } = payload;
    let alerts = yield select(({ App }) => App.alerts);
    const { newUser } = yield select(state => state.users);
    const editedUser = {
        cpf: newUser.cpf,
        gender: newUser.gender,
        nickname: newUser.nickname,
        phone_number: newUser.phone_number,
    };
    yield put({ type: actions.TOGGLE_WAIT_FOR_REQUEST, payload: true });

    try {
        yield call(editUser, newUser.id, editedUser);
        yield put({ type: actions.TOGGLE_WAIT_FOR_REQUEST, payload: false });
        alerts.push({
            type: 'success',
            title: 'Sucesso',
            message: 'Usuário atualizado com sucesso',
        });
        yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
        yield put({ type: actions.TOGGLE_SHOW_FORM, payload: false });
        yield put({ type: actions.IS_THIS_EDITING, payload: false });
        yield put({ type: actions.CLEAR_NEW_USER });
        yield call(callback, true);
    } catch (error) {
        yield put({ type: actions.TOGGLE_WAIT_FOR_REQUEST, payload: false });
        if (
            error.response.data.error_description ===
            'Invalid phone number format.'
        ) {
            alerts.push({
                type: 'error',
                title: 'Erro',
                message: 'Número de telefone inválido. Tente novamente',
            });
            yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
        } else if (error.response.status === 451) {
            alerts.push({
                type: 'error',
                title: 'Erro',
                message:
                    'Você não tem permissão para editar esse usuário, entre em contato com o suporte',
            });
            yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
        } else {
            alerts.push({
                type: 'error',
                title: 'Erro',
                message: 'Não foi possivel editar o usuário. Tente novamente',
            });
            yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
        }
    }
}

function* createAlertCustom({ payload }) {
    const { type, title, message } = payload;
    let alerts = yield select(({ App }) => App.alerts);
    alerts.push({ type, title, message });
    yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
}

// eslint-disable-next-line no-unused-vars
function* checkInfoRealmsUser({ payload }) {
    let alerts = yield select(({ App }) => App.alerts);
    const searchError = {
        type: 'error',
        title: 'Erro',
        message: 'Não foi possível realizar a busca pelo usuário',
    };

    let userInfo;
    try {
        const { data } = yield call(fetchUser, payload.email);
        userInfo = data;
    } catch (err) {
        if (err.response && err.response.status === 404) {
            userInfo = null;
        } else {
            alerts.push(searchError);
            yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
        }
    }

    let hasRealm;
    if (userInfo) {
        if (
            typeof userInfo.enrollments === 'undefined' ||
            userInfo.enrollments === null ||
            userInfo.enrollments.length === 0
        ) {
            hasRealm = false;
        } else if (userInfo.enrollments.length > 0) {
            hasRealm = true;
        }
    }

    if (hasRealm === true) {
        // user already register and already register in realm
        alerts.push({
            type: 'error',
            title: 'Erro',
            message: 'Aluno já está cadastrado no EAD.',
        });
        yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
    } else if (hasRealm === false) {
        // user already register and not register in realm
        yield put({
            type: actions.CHECK_INFO_ABOUT_REALMS_USER,
            payload: { hasRealm: false },
        });
        yield put({
            type: actions.TOGGLE_SHOW_SWITCH_ADD_REALMS,
            payload: true,
        });
        yield put({
            type: actions.TOGGLE_SHOW_FORM_SEARCH_REALMS,
            payload: false,
        });
        yield put({ type: actions.SET_NEW_USER, payload: { ...userInfo } });
        // user not register and not register in realm
    } else if (userInfo === null) {
        yield put({
            type: actions.CHECK_INFO_ABOUT_REALMS_USER,
            payload: null,
        });
        yield put({ type: actions.TOGGLE_SHOW_FORM, payload: true });
        yield put({
            type: actions.TOGGLE_SHOW_FORM_SEARCH_REALMS,
            payload: false,
        });
        yield put({
            type: actions.EDIT_NEW_USER,
            payload: { id: 'email', value: payload.email },
        });
    } else {
        alerts.push(searchError);
        yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
    }
}

export default function* users() {
    yield takeEvery(actions.ASYNC_FETCH_SOME_USERS, fetchCoaches);
    yield takeEvery(actions.ASYNC_FETCH_USER_DATA, fetchOneUserDataByClass);
    yield takeEvery(actions.ASYNC_FETCH_USER_ENROLLMENTS, fetchUserEnrollments);
    yield takeEvery(actions.ASYNC_FETCH_ALL_USERS, fetchAllCoaches);
    yield takeEvery(actions.ASYNC_EDIT_NEW_USER, asyncEditNewUser);
    yield takeEvery(actions.ASYNC_CREATE_USER, asyncCreateUser);
    yield takeEvery(actions.INIT_EDIT_USER, initEditUser);
    yield takeEvery(actions.FINISH_EDIT_USER, finishEditUser);
    yield takeEvery(actions.ASYNC_CREATE_ALERT, createAlertCustom);
    yield takeEvery(
        actions.ASYNC_CHECK_INFO_ABOUT_REALMS_USER,
        checkInfoRealmsUser,
    );
}



// WEBPACK FOOTER //
// ./src/components/users/user.saga.js